import script from "./TaskTreeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskTreeTable.vue?vue&type=script&setup=true&lang=js"

import "./TaskTreeTable.vue?vue&type=style&index=0&id=6957dfe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6957dfe8"]])

export default __exports__